import React from 'react';

// import { getMembers, cleanMembers } from 'models/member';
import { CustomRoute } from 'util/hook/useRouter';

// export const sleep = (time: number): Promise<undefined> =>
// 	new Promise(resolve => setTimeout(resolve, time));

const routes: CustomRoute = {
	path: '/member',
	components: () => [import(/* webpackChunkName: 'members' */ './component')],
	render: ([Member]) => <Member />,
	onEnter: async ({ store, history }) => {
		console.log('on Enter member');

		const { login } = store.getState();
		const [isExpired, isNotGrMember] = [login.isGrMember.expired, !login.isGrMember.isMember];
		// console.log(isExpired, 'isExpired');
		// console.log(isNotGrMember, 'isNotGrMember');

		// token 過期 or 非會員 皆無法進入會員頁
		if (isExpired || isNotGrMember) {
			history.replace('/');
		}
		console.log('on Enter member / end');

		// 示範代碼：
		// await store.dispatch(cleanMembers());
		// await store.dispatch(getMembers());
		// await sleep(5000);
	},
};
export default routes;
